import {Component, OnInit} from '@angular/core';
import {OwnerCrudService} from '../services/owner-crud.service';
import {LeadService} from '../../leads/services/lead.service';
import {Router, ActivatedRoute} from '@angular/router';
import {OwnersForm} from '../models/data-model';
import {GlobalDataService} from "../../housekeeping/services/global-data.service";

@Component({
    selector: 'app-owner-crud',
    templateUrl: '../views/owner-crud.component.html',
    styleUrls: ['../css/owner-crud.component.css']
})
export class OwnerCrudComponent implements OnInit {
    public vehicleData: any;
    public ownerId = "";
    public Ownerchage = "No";
    public errorMessage = "";
    public make: string;
    public model: string;
    public countryCode: string = "";
    public salesType: string = "";
    public statusCode: string = "";
    public vin: any = null;
    public purchaseDate: Date = null;
    public warrantyDate: Date = null;
    public year: number = null;
    //public userId = localStorage.getItem('userId');
    public userId = sessionStorage.getItem('userId');
    public countryList: any;
    public ownerheadername = "CREATE OWNER";
    public butDisabled: boolean = false;
    public optedIn;
    public prevFirstName:string = "";
    public prevLastName:string = "";

    public ownersForm = new OwnersForm(

        null, null,null, null, null, null, null, null, null, null, null, null, null, {}, {}, null, {}, null,
        {
            id: "",
            address1: "",
            address2: "",
            address3: "",
            address4: "",
            city: "",
            postalCode: null,
            stateId: {
                id: null,
                stateCode: null,
                name: ""
            },
            countryId: {
                id: null,
                code: null,
                name: ""
            }
        }, null, [
            {
                id: null,
                sugarVKey: null,
                individualId: null,
                vin: null,
                purchaseDate: Date,
                warrantyDate: Date,
                cycle: {
                    id: null,
                    code: "",
                    description: "",
                    active: null
                },
                salesType: {
                    id: null,
                    code: "",
                    description: "",
                    active: null
                },
                vehicleType: {
                    id: null,
                    make: "",
                    model: ""
                },
                year: null,
                dateEntered: Date,
                createdBy: null,
                dateModified: null,
                modifiedBy: null,
                deleted: null,
                dateSynced: null
            }
        ]
    );
    public dealerName:string="";
    public dealerGlobalCode:string="";
    submitted:boolean = false
    public ownerVehicleId:string =""
    constructor(public _ownerCrudService: OwnerCrudService, public _leadService: LeadService, public activeroute: ActivatedRoute, public _router: Router, public _dataService: GlobalDataService ) {}

    ngOnInit() {
        this.getCountryList();
       // this.Ownerchage = "No"
        this.activeroute.params.subscribe(
            params => {
                if (Object.keys(params).length != 0) {
                    this.ownerId = params.id;
                    this.vin = params.vin;
                    this.ownerVehicleId = params.vehicleId
                    this.ownerheadername =  "EDIT OWNER";
                     this.butDisabled=true;
                  /*  if (typeof params.owner != "undefined"){
                        this.Ownerchage = params.owner

                    } */

                }
            });
        this.getOwnerDetails();
       /* if (this.Ownerchage != 'No')
            this.ownersForm.id = null;*/
    }
       /**
     * @author Pradeep
     * @description get country list
     */
    getCountryList() {
        this._leadService.getCountryList(this.userId, (result) => {
            this.countryList = result;
        });
    }
    getOwnerDetails() {

        this._ownerCrudService.viewOwnerDetails(this.vin, this.ownerId, this.userId,this.ownerVehicleId, (result) => {
            this.ownersForm = result;
            this.prevFirstName =result.firstName;
            this.prevLastName = result.lastName;
            this.vehicleData = result.vehicles;
            if(this.ownersForm.addressId.countryId != null){
                this.countryCode = this.ownersForm.addressId.countryId.name + " " +"("+this.ownersForm.addressId.countryId.code+")";
            }else{
                this.countryCode="";
            }
            if (this.vehicleData.length != 0) {

                for(let index=0; index < this.vehicleData.length; index++){
                    if(this.vehicleData[index].vin == this.vin){
                        if (result.vehicles[index].ownershipStatus != null) {
                    this.statusCode = this.vehicleData[index].ownershipStatus;
                    }
                    else {
                        this.statusCode = "";
                    }
                    if (this.vehicleData[index].salesType != null) {
                        this.salesType = this.vehicleData[index].salesType.description;
                    }
                    else {
                        this.salesType = "";
                    }
                    if (this.vehicleData[index].vehicleType != null) {
                        this.make = this.vehicleData[index].vehicleType.make;
                        this.model = this.vehicleData[index].vehicleType.model;
                    }
                    else {
                        this.make = "";
                        this.model = "";
                    }
                    if(result.optedIn)
                        this.optedIn = "Yes";

                    this.vin = this.vehicleData[index].vin;
                    this.purchaseDate = this.vehicleData[index].purchaseDate;
                    this.warrantyDate = this.vehicleData[index].warrantyDate;
                    this.year = this.vehicleData[index].year;
                    }
                }

            }
            else {
                this.make = "";
                this.model = "";
                this.salesType = "";
                this.statusCode = "";
                this.vin = null;
                this.purchaseDate = null;
                this.year = null;
            }
            if (this.ownersForm.dealerId != null){
                this.dealerName = this.ownersForm.dealerId.name;
                this.dealerGlobalCode = this.ownersForm.dealerId.globalCode
            }
            else{
                this.dealerName = "";
                this.dealerGlobalCode = "";
            }

        });
    }
    saveOwner() {
        this.errorMessage = "";
        this.ownersForm.vehicles = this.vehicleData;
        this.ownersForm.userId = Number(this.userId);
          this._dataService.trackUserClick(this.userId,"OwnerSave_FN:"+this.prevFirstName+"->"+this.ownersForm.firstName);
          this._dataService.trackUserClick(this.userId,"OwnerSave_LN:"+this.prevLastName+"->"+this.ownersForm.lastName);
        this._ownerCrudService.saveOwner(this.ownersForm, (result) => {
            if (result.statusCodes == "OWNER_SAVED_SUCCESSFULLY") {
                this.ownerId=result.id;
                if(this.ownerId!="" && this.ownerId!=undefined )
                {
                    this._router.navigate(['owners/detail/'+this.ownerId+'/'+this.vin+'/'+this.ownerVehicleId]);
                }else{
                    this._router.navigate(["owners"]);
                }
            }
            else {
                this.ownersForm.vehicles = this.vehicleData[0];
                this.errorMessage = "Failed to update owner."
            }
        });

    }
    /**
     * @author Sowmya
     * @description cancel create or edit
     */
    cancel(){
      if(this.ownerId!="" && this.ownerId!=undefined )
        {
            this._router.navigate(['owners/detail/'+this.ownerId+'/'+this.vin+'/'+this.ownerVehicleId]);
        }else{
            this._router.navigate(["owners"]);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/owners/components/owner-crud.component.ts